import { render, staticRenderFns } from "./OfferReviewPanel.vue?vue&type=template&id=0e04f31c&"
import script from "./OfferReviewPanel.vue?vue&type=script&lang=js&"
export * from "./OfferReviewPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports